import ConversationList from 'components/ai-chat-board/ConversationList';
import moment from 'moment';
import { Button } from 'primereact/button';
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContent, toast } from 'react-toastify';
import { handleLoader, setStopId } from 'redux/counterSlice';
import { handleActive, handleLength, handlePurpose, handleRole, handleStyle, handleTopic } from 'redux/persistentSlice';
import { AppDispatch } from 'redux/store';
import * as myconst from "../../constants"
import EmailGeneration from 'components/solutions/EmailGeneration';
import { deleteConversationEmail, emailHistory, emailHistoryById, emailHistoryByVersion } from 'services/emailService';

interface Answer {
  que: string;
  ans: {
    response: {
      output_text: string;
    };
    isFirst: boolean;
  };
}
interface Query {
  que: string;
  isUser: boolean;
}

const GenerateArtical = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const params = useParams();
  const editDeleteContainerRef = useRef(null);
  const [current, setCurrent] = useState(null);
  const [userQuery, setUserQuery] = useState<Query[]>([]);
  const [answer, setAnswer] = useState<Answer[]>([]);
  const [data, setData] = useState({});
  const [emailData, setEmailData] = useState({});
  const [visibleRight, setVisibleRight] = useState<boolean>(false);
  const [showEditDelete, setShowEditDelete] = useState({});
  const [hover, setHover] = useState(null);
  const [isDeleteClicked, setIsDeleteClicked] = useState([]);
  const [delId, setDelId] = useState('');
  const [languageTranslated, setLanguageTranslated] = useState({ name: "English" });
  const [deleteConfirmation, setDeleteConfirmation] = useState<any>({
    date: null,
    index: null,
  });

  const notify = (toastmsg: any) => {
    return toast(toastmsg, {
      position: 'bottom-center',
      style: {
        backgroundColor: '#F1F1F1', // Grey background
      }

    });
  };
  const handleGetConversation = async (id: any) => {
    const synth = window.speechSynthesis;
    if (synth.speaking) {
      synth.cancel();
      dispatch(setStopId(''));
    }
    const startTime = performance.now(); // Start the timer
    dispatch(handleLoader(true));
    try {
      setUserQuery([]);
      setAnswer([]);
      setCurrent(id);
      const { result, error } = await emailHistoryById(id, "article_generation");
      if (error) {
        throw error
      }
      if (result?.error) {
        throw result.error
      }
      setEmailData(result?.latest_record);
      const settings = result?.latest_record.settings;
      dispatch(handleRole({ name: settings.role }));
      dispatch(handleStyle({ name: settings.style }));
      dispatch(handleLength({ name: settings.length }));
      dispatch(handleTopic(settings.topic));
      dispatch(handlePurpose(settings.purpose));
      const endTime = performance.now(); // End the timer
      const elapsedTime = endTime - startTime; // Calculate elapsed time
      let chatAns: any = [];
      let chatQue: any = [];
      let newQuery = {
        que: result?.latest_record?.prompt,
        isUser: true,
      };
      // result?.message.forEach((data: any) => {
      //   let newQuery = {
      //     que: data.question?.content?.parts[0],
      //     isUser: true,
      //   };
      //   chatQue.push(newQuery);
      //   let obj = {
      //     ans: {
      //       response: {
      //         output_text: data.answer?.content?.parts.join("\n")
      //       },
      //       id: data.answer?.id,
      //       rating: data.answer?.content?.rating,
      //       created_time: data.answer?.content?.created_at,
      //       feedback: data.answer?.content?.feedback_text,
      //       source_info: data.answer?.content?.source_info,
      //       response_time: elapsedTime.toFixed(2)
      //     },
      //   };


      //   chatAns.push(obj);
      // });
      let obj: any = {
        ans: {
          response: {
            output_text:
              result?.latest_record?.content?.replace(/`/g, "\n\n"),
          },
          subject: result?.latest_record?.subject,
          id: result?.latest_record?.message_id,
          created_time: result?.latest_record?.created_at,
          version: result?.latest_record?.version,
          total_versions: result?.total_count,
        },
      };
      setAnswer([obj]);
      setUserQuery([newQuery]);
      if (result?.latest_record?.language !== undefined) {
        setLanguageTranslated({ name: myconst.capitalizeFirstLetter(result?.latest_record?.language) })
      } else {
        setLanguageTranslated({ name: "English" })
      }
      // setLanguageTranslated({ name: myconst.capitalizeFirstLetter(result?.latest_record?.language[0]) })
      dispatch(handleLoader(false));
    } catch (error) {
      toast.error(error as ToastContent<unknown>, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
      dispatch(handleLoader(false));
    }
  };
  const getConversations = async () => {
    try {
      const { result, error } = await emailHistory("article_generation");
      if (error) {
        throw error
      }
      if (result?.error) {
        throw result.error
      }
      let sortedConversations: any;
      sortedConversations = result.sort((a: any, b: any) => {
        const dateA: any = moment(a.created_at);
        const dateB: any = moment(b.created_at);
        return dateB - dateA;
      });
      // Group conversations by date
      const conversationsByDate: any = {};
      sortedConversations.forEach((conversation: any) => {
        const date = moment(conversation.created_at).format(
          'YYYY-MM-DD'
        );
        if (!conversationsByDate[date]) {
          conversationsByDate[date] = [];
        }
        conversationsByDate[date].push(conversation);
      });
      // Organize conversations into different phases
      const today = moment().format('YYYY-MM-DD');
      const yesterday = moment()
        .subtract(1, 'days')
        .format('YYYY-MM-DD');
      const previous7Days = moment()
        .subtract(7, 'days')
        .format('YYYY-MM-DD');
      const previous30Days = moment()
        .subtract(30, 'days')
        .format('YYYY-MM-DD');

      const organizedData: any = {};

      // Add conversations for "Today"
      organizedData['Today'] = conversationsByDate[today] || [];

      // Add conversations for "Yesterday"
      organizedData['Yesterday'] =
        conversationsByDate[yesterday] || [];

      // Add conversations for "Previous 7 days" excluding conversations in "Today" and "Yesterday"
      organizedData['Previous 7 days'] = Object.keys(
        conversationsByDate
      )
        .filter((date) =>
          moment(date).isBetween(
            previous7Days,
            yesterday,
            null,
            '[]'
          )
        )
        .map((date) => conversationsByDate[date])
        .flat()
        .filter((conversation) => {
          const conversationDate = moment(
            conversation.created_at
          ).format('YYYY-MM-DD');
          return (
            conversationDate !== today &&
            conversationDate !== yesterday
          );
        });

      // Add conversations for "Previous 30 days" excluding conversations in "Previous 7 days"
      organizedData['Previous 30 days'] = Object.keys(
        conversationsByDate
      )
        .filter((date) =>
          moment(date).isBetween(
            previous30Days,
            previous7Days,
            null,
            '[]'
          )
        )
        .map((date) => conversationsByDate[date])
        .flat()
        .filter(
          (conversation) =>
            moment(conversation.created_at).format(
              'YYYY-MM-DD'
            ) !== today &&
            moment(conversation.created_at).format(
              'YYYY-MM-DD'
            ) !== yesterday
        );

      // Organize conversations by month, excluding the current month
      const conversationsByMonth: any = {};
      sortedConversations.forEach((conversation: any) => {
        const month = moment(conversation.created_at).format(
          'MMMM YYYY'
        );
        if (month !== moment().format('MMMM YYYY')) {
          if (!conversationsByMonth[month]) {
            conversationsByMonth[month] = [];
          }
          conversationsByMonth[month].push(conversation);
        }
      });

      // Add conversations by month to the organized data
      for (const month in conversationsByMonth) {
        organizedData[month] = conversationsByMonth[month];
      }
      setData(organizedData);
    } catch (error) {
      toast.error(error as ToastContent<unknown>, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
    }
  };
  const handleCoversationByVersion = async (version: number) => {
    setAnswer([]);
    try {
      const { result, error } = await emailHistoryByVersion(params.id, "article_generation", version);
      if (error) {
        throw error
      }
      if (result?.error) {
        throw result.error
      }
      // let newQuery = {
      //   que: result?.email_summary,
      //   isUser: true,
      // };
      // setUserQuery([newQuery]);
      // setUserQuery([...userQuery, newQuery]);
      setEmailData(result?.latest_email_history)
      const settings = result?.latest_email_history.settings;
      dispatch(handleRole({ name: settings.role }));
      dispatch(handleStyle({ name: settings.style }));
      dispatch(handleLength({ name: settings.length }));
      dispatch(handleTopic(settings.topic));
      dispatch(handlePurpose(settings.purpose));
      let obj: any = {
        ans: {
          response: {
            output_text:
              result?.latest_email_history?.content?.replace(/`/g, "\n\n"),
          },
          subject: result?.latest_email_history?.subject,
          id: result?.latest_email_history?.message_id,
          created_time: result?.latest_email_history?.created_at,
          version: result?.latest_email_history?.version,
          total_versions: result?.total_count
        },
      };
      setAnswer([obj]);
      if (result?.latest_email_history?.language !== undefined) {
        setLanguageTranslated({ name: myconst.capitalizeFirstLetter(result?.latest_email_history?.language) })
      } else {
        setLanguageTranslated({ name: "English" })
      }
      // setLanguageTranslated({ name: myconst.capitalizeFirstLetter(result?.latest_email_history?.language[0]) })
    } catch (error) {
      toast.error(error as ToastContent<unknown>, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
      dispatch(handleLoader(false));
    }
  }
  //handle delete button
  const handleDelete = async (date: any, index: any) => {
    try {
      const { result, error } = await deleteConversationEmail(delId, "article_generation");
      if (error) {
        throw error
      }
      if (result?.error) {
        const updatedIsDeleteClicked: any = [...isDeleteClicked];
        updatedIsDeleteClicked[index] = false;
        setIsDeleteClicked(updatedIsDeleteClicked);
        throw result.error
      }
      toast.success('Conversation deleted successfully', {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      });
      if (delId === params.id) {
        // handleNewChatButton();
        setHover(null);
        setCurrent(null);
        navigate(`/generate-article/new-article`);
        // setVisibleRight(false)
        setUserQuery([]);
        setAnswer([]);
        dispatch(handleActive("generateArticle"))
      }
      const updatedIsDeleteClicked: any = [...isDeleteClicked];
      updatedIsDeleteClicked[index] = false;
      setIsDeleteClicked(updatedIsDeleteClicked);
      getConversations();

    } catch (error) {
      toast.error(error as ToastContent<unknown>, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      });
    }
  };
  const handleDeleteIconClicked = (date: any, index: any, id: any) => {
    setDelId(id);
    const updatedIsDeleteClicked: any = [...isDeleteClicked];
    updatedIsDeleteClicked[index] = true;
    setIsDeleteClicked(updatedIsDeleteClicked);
    setDeleteConfirmation({ date, index });
    if (editDeleteContainerRef.current) setShowEditDelete({});
  };
  useEffect(() => {
    navigate(`/generate-article/${params.id}`);
    if (params.id !== 'new-article' && params.id !== undefined) {
      handleGetConversation(params.id);

    }
    // else {
    //     handleNewChatButton();
    // }
  }, []);
  useEffect(() => {
    const handleBackButton = () => {
      if (params.id !== 'new-article' && params.id !== undefined) {
        handleGetConversation(params.id);
      }
      // else {
      //     handleNewChatButton();
      // }
    };

    // Listen for the popstate event (browser back/forward button click)
    window.addEventListener('popstate', handleBackButton);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);
  useEffect(() => {
    const handleBackButton = () => {
      if (params.id !== 'new-article' && params.id !== undefined) {
        handleGetConversation(params.id);
      }
      // else {
      //     handleNewChatButton();
      // }
    };

    // Listen for the popstate event (browser back/forward button click)
    window.addEventListener('popstate', handleBackButton);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);
  let featureHistory: any = JSON.parse(localStorage.getItem("feature-flag") || '{}');
  const historyFlag = featureHistory[myconst.FEATURE_FLAG_KEY.history]
  return (
    <main className="content-wrapper">
      <EmailGeneration
        setCurrent={setCurrent}
        deleteConfirmation={deleteConfirmation}
        userQuery={userQuery}
        setUserQuery={setUserQuery}
        setAnswer={setAnswer}
        answer={answer}
        notify={notify}
        emailData={emailData}
        setEmailData={setEmailData}
        handleDelete={handleDelete}
        handleCoversationByVersion={handleCoversationByVersion}
        isDeleteClicked={isDeleteClicked}
        setIsDeleteClicked={setIsDeleteClicked}
        component={"generate-article"}
        p_id={"new-article"}
        getConversations={getConversations}
        source_name={"article_generation"}
        languageTranslated={languageTranslated}
        setLanguageTranslated={setLanguageTranslated}
      />
      {(historyFlag === true || historyFlag === undefined) &&
        <>
          <Button label="Chat History" outlined icon="pi pi-history" className='outline-icon-btn chat-history-btn' onClick={() => setVisibleRight(true)} />
          <ConversationList
            current={current}
            setCurrent={setCurrent}
            handleGetConversation={handleGetConversation}
            data={data}
            setVisibleRight={setVisibleRight}
            visibleRight={visibleRight}
            setData={setData}
            hover={hover}
            showEditDelete={showEditDelete}
            setShowEditDelete={setShowEditDelete}
            setHover={setHover}
            getConversations={getConversations}
            handleDelete={handleDelete}
            handleDeleteIconClicked={handleDeleteIconClicked}
            emailData={emailData}
            setEmailData={setEmailData}
            component={"generate-article"}
            source_name={"article_generation"}
          />
        </>}
    </main>
  )
}


export default GenerateArtical